import { render, staticRenderFns } from "./DepartmentOwnershipField.vue?vue&type=template&id=5c9d4e0a"
import script from "./DepartmentOwnershipField.vue?vue&type=script&lang=js"
export * from "./DepartmentOwnershipField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports